import { Flex } from 'antd';
import { FC } from 'react';

import { PCIcon, PhoneIcon, TabletIcon } from '@/common/components';

import { SearchConsoleAnalyticsDevicesDimension } from '@/modules/DomainsApi';

interface Props {
  value: SearchConsoleAnalyticsDevicesDimension['key'];
}

export const DevicesLabel: FC<Props> = ({ value }) => {
  if (value === 'DESKTOP') return <Flex align="center" gap={ 4 }><span>ПК</span><PCIcon/></Flex>;
  if (value === 'MOBILE') return <Flex align="center" gap={ 4 }><span>Мобільні</span><PhoneIcon/></Flex>;
  if (value === 'TABLET') return <Flex align="center" gap={ 4 }><span>Планшети</span><TabletIcon/></Flex>;
};
